import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './AdminLayout.css';
import logo_img from "../../assets/Impact stories fund logo .png";
import { IoHome } from "react-icons/io5";
import { GiFilmSpool } from "react-icons/gi";
import { FaUpload } from "react-icons/fa";

const AdminLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => {
    return location.pathname.includes(path);
  };

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    navigate('/admin/login');
  };

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="sidebar-header">
          <img src={logo_img} alt="ISF Logo" className="sidebar-logo" />
          <h2>Admin Dashboard</h2>
        </div>
        
        <nav className="sidebar-nav">
          <Link 
            to="/dashboard" 
            className={`nav-item ${isActive('/dashboard') && !isActive('/admin/upload') ? 'active' : ''}`}
          >
            <IoHome />
            Dashboard
          </Link>
          
          <Link 
            to="/films" 
            className={`nav-item ${isActive('/films') && !isActive('/films/upload') ? 'active' : ''}`}
          >
            <GiFilmSpool />
            Films
          </Link>

          <Link to="/films/upload" className={`nav-item ${isActive('/films/upload') ? 'active' : ''}`}>
            <FaUpload />
            Upload Film
          </Link>


          
          
          <div className="nav-section">
            {/* <p className="section-label">Tools</p>
            <a href="/api/subscribers/export" className="nav-subitem" target="_blank" rel="noopener noreferrer">
              📥 Export Subscribers
            </a> */}
            <button onClick={handleLogout} className="btn-logout">
            Logout
          </button>
          </div>
        </nav>
        
        {/* <div className="sidebar-footer">
          <Link to="/" className="back-to-site">
            ← View Site
          </Link>
        </div> */}
      </aside>
      
      <main className="admin-main">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;